import cn from 'clsx'

import './IconStat.scss'
import {Box, Text} from 'common/components'

interface StatProps {
  className?: string
  isError?: boolean
  row?: boolean
  icon: JSX.Element
  iconColor?: IconColor
  title?: string
  value: string | number | JSX.Element
  label: string | JSX.Element
  align?: 'left' | 'center' | 'right'
}

export type IconColor = 'default' | 'green' | 'turquoize'

export default function IconStat({
  className,
  isError,
  row,
  icon,
  iconColor = 'default',
  title,
  value,
  label,
  align,
}: StatProps) {
  return (
    <Box
      className={cn(
        className,
        'IconStat',
        row && 'IconStat_row',
        isError && 'IconStat_error'
      )}
      align={align}
    >
      <div className={`IconStat-Wrap IconStat-Wrap_color_${iconColor}`}>
        {icon}
      </div>
      <div style={align === 'center' ? null : {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
      }}>
        {title && (
          <Text weight="medium" mt={6} mb={2}>
            {title}
          </Text>
        )}
        <Box size="3xl" weight="medium" mb={4}>
          {value}
        </Box>
        <Text size="xs" weight="medium" color={isError ? 'redError' : 'grey'}>
          {label}
        </Text>
      </div>
    </Box>
  )
}
